import { RouteModule } from '#/horizon/components/RouteModule';
import { useI18n } from '#/i18n/hooks/useI18n';
import type { LayoutHandleProps } from '#/layouts/Layout/LayoutHandleProps';
import { orgDashboardApiIsomorphicFetchCreditsForPurchase } from '#/modules/orgDashboard/api/orgDashboardApiFetchCreditsForPurchase';
import { orgDashboardBuyCreditPacksRoute } from '#/modules/orgDashboard/routing/orgDashboard.routes';
import type { HorizonAppRouteLoaderArgs } from '#/routing/classes/types/AppRouteLoaderArgs';
import type { HorizonAppRouteComponentProps } from '#/routing/types/HorizonAppRouteComponentProps';

import { OrgDashboardBuyCreditPacksPageLoadable } from './OrgDashboardBuyCreditPacksPageLoadable';

export const handle = {
  fallbackUrlByLocaleToCurrent: true,
  darkBackground: true,
  showDesktopSearch: true,
} satisfies LayoutHandleProps;

export async function loader({
  request,
  context,
  params: { orgId },
}: HorizonAppRouteLoaderArgs<typeof orgDashboardBuyCreditPacksRoute>) {
  const [forPurchase] = await Promise.all([
    orgDashboardApiIsomorphicFetchCreditsForPurchase({ request, context })(
      orgId,
    ),
    OrgDashboardBuyCreditPacksPageLoadable.load(),
  ]);

  return { forPurchase };
}

export default function OrgDashboardBuyCreditPacksHorizonRoute({
  loaderData: { forPurchase },
}: HorizonAppRouteComponentProps<typeof loader>) {
  const { i18n } = useI18n();

  return (
    <RouteModule title={i18n('Buy Credit Packs')}>
      <OrgDashboardBuyCreditPacksPageLoadable forPurchase={forPurchase} />
    </RouteModule>
  );
}
